<template>
<div id="faqs">

<!-- Breadcrumbs -->
    <section class="city-breadcrumb"></section>
        <div class="row breadcrumb-box">
            <div class="mr-3 ml-5">
                <p class="mbr-text city-footer-font-bread display-7 ">
                    <a class="city-footer-link-sub" href="/">Home</a> > {{ title }}</p>
            </div>
        </div> 

<!-- Content -->
        <div class="container">
            <div class="row">
                <div class="card container-fluid ml-3">
                    <img class="card-img-top mt-3" id="card-img-base64">
                    <div class="card-body mb-5">
                        <h1 class="city-title mt-2 ">{{ title }}</h1>
                        <div class="large-city-green-div "></div>
                        <div class="">

                        <div id="accordion">

                                  <div class="card">
                                    <div class="card-header" id="headingOne">
                                      <h5 class="mb-0">
                                        <button class="btn btn-link collapsed city-p text-left" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                          1. What is a consent decree?
                                        </button>
                                      </h5>
                                    </div>
                                    <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordion">
                                      <div class="card-body city-p">
                                         Consent decrees are agreements that make sure cities, businesses and industries follow federal regulations. The consent decree is filed with the court and approved by a judge that formalizes the agreement.
                                      </div>
                                    </div>
                                  </div>

                                  <div class="card">
                                    <div class="card-header" id="headingTwo">
                                      <h5 class="mb-0">
                                        <button class="btn btn-link collapsed city-p text-left" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                          2. Why is the City of Corpus Christi entering into a consent decree?
                                        </button>
                                      </h5>
                                    </div>
                                    <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordion">
                                      <div class="card-body city-p">
                                        The City is entering into a consent decree to resolve disputes with the EPA. Our negotiated agreement with the EPA prevents costly court litigation and allows the City to have oversight and management of repairs and/or renovations unique to our system’s conditions.
                                      </div>
                                    </div>
                                  </div>

                                  <div class="card">
                                    <div class="card-header" id="headingThree">
                                      <h5 class="mb-0">
                                        <button class="btn btn-link collapsed city-p text-left" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                          3. Is Corpus Christi the only city with a consent decree with the EPA?
                                        </button>
                                      </h5>
                                    </div>
                                    <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordion">
                                      <div class="card-body city-p">
                                       Consent decrees are a method used to address various issues between municipalities, businesses, and the Federal Government. Corpus Christi is not the only city with a consent decree with the EPA.  To understand more about EPA settlements, <a href="https://www.epa.gov/enforcement">visit the EPA online</a>.
                                      </div>
                                    </div>
                                  </div>

                                  <div class="card">
                                    <div class="card-header" id="headingFour">
                                      <h5 class="mb-0">
                                        <button class="btn btn-link collapsed city-p text-left" data-toggle="collapse" data-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                          4. What is a sanitary sewer overflow?
                                        </button>
                                      </h5>
                                    </div>
                                    <div id="collapseFour" class="collapse" aria-labelledby="headingFour" data-parent="#accordion">
                                      <div class="card-body city-p">
                                        A sanitary sewer system is designed to collect and transport wastewater to a wastewater treatment plant. An overflow occurs when the sanitary sewer system releases raw, untreated sewage.
                                      </div>
                                    </div>
                                  </div>

                                  <div class="card">
                                    <div class="card-header" id="headingFive">
                                      <h5 class="mb-0">
                                        <button class="btn btn-link collapsed city-p text-left" data-toggle="collapse" data-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                                          5. Why are sanitary sewer overflows a problem? 
                                        </button>
                                      </h5>
                                    </div>
                                    <div id="collapseFive" class="collapse" aria-labelledby="headingFive" data-parent="#accordion">
                                      <div class="card-body city-p">
                                        The greatest threat from sanitary sewer overflows is the potential for sewage to impact homes or businesses, causing property damage and threatening public health.  The bacteria in raw sewage poses a threat to the ecosystem in our bays leading to beach warnings or closures. 
                                      </div>
                                    </div>
                                  </div>

                                  <div class="card">
                                    <div class="card-header" id="headingSix">
                                      <h5 class="mb-0">
                                        <button class="btn btn-link collapsed city-p text-left" data-toggle="collapse" data-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
                                          6. What causes sanitary sewer overflows? 
                                        </button>
                                      </h5>
                                    </div>
                                    <div id="collapseSix" class="collapse" aria-labelledby="headingSix" data-parent="#accordion">
                                      <div class="card-body city-p">
                                        There are several factors that can lead to sanitary sewer overflows including but not limited to: 
                                        <ul>
                                            <li>Rainwater infiltrating pipes causes overflows</li>
                                            <li>New residential and commercial growth are dependent on existing-aging infrastructure</li>
                                            <li>Incorrect items thrown down the drain </li>
                                            <li>Breaking pipes</li>
                                        </ul> 
                                      </div>
                                    </div>
                                  </div>

                                  <div class="card">
                                    <div class="card-header" id="headingSeven">
                                      <h5 class="mb-0">
                                        <button class="btn btn-link collapsed city-p text-left" data-toggle="collapse" data-target="#collapseSeven" aria-expanded="false" aria-controls="collapseSeven">
                                          7. How will this impact water and wastewater bills?
                                        </button>
                                      </h5>
                                    </div>
                                    <div id="collapseSeven" class="collapse" aria-labelledby="headingSeven" data-parent="#accordion">
                                      <div class="card-body city-p">
                                        The City of Corpus Christi worked with the EPA to ensure the consent decree was the most cost-effective use of customer dollars. The impact is expected to be minimal and spread out over time.
                                      </div>
                                    </div>
                                  </div>

                                  <div class="card">
                                    <div class="card-header" id="headingEight">
                                      <h5 class="mb-0">
                                        <button class="btn btn-link collapsed city-p text-left" data-toggle="collapse" data-target="#collapseEight" aria-expanded="false" aria-controls="collapseEight">
                                          8. How can I help prevent sanitary sewer overflows?
                                        </button>
                                      </h5>
                                    </div>
                                    <div id="collapseEight" class="collapse" aria-labelledby="headingEight" data-parent="#accordion">
                                      <div class="card-body city-p">
                                        Here are 5 simple things you can do to prevent sanitary sewer overflows:
                                        <ol>
                                          <li>Never pour fats, oils, or grease (F.O.G.) down the drain or garbage disposal.</li>
                                          <li>Only flush the 3 Ps - Pee, Poo and toilet Paper.</li>
                                          <li>Throw wipes, including ones labeled “flushable, plumber approved”, in the trash can.</li>
                                          <li>Cap your sanitary sewer clean out.</li>
                                          <li>Learn more about how you can <a href="./doing.html">Do Your Part&nbsp;»</a></li>
                                        </ol>
                                      </div>
                                    </div>
                                  </div>

                                </div>

                   </div> <!-- Content Here -->
                </div> 
            </div>
        </div>
    </div>
</div>

</template>

<script>
export default {
  name: 'faqs',
  data () {
    return {
        title: 'Frequently Asked Questions',
        crumbLink:'',
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/Faqs.vue